import { BudgetBys } from 'business/constants';
import {
    NO_SERVICE,
    NO_GESTIONNAIRE,
} from 'routes/BudgetModule/config/constants';

export const getNoResourceText = (by: BudgetBys): string =>
    by === BudgetBys.GESTIONNAIRE ? NO_GESTIONNAIRE : NO_SERVICE;
